import { ErrorHandler, Injectable, Injector } from '@angular/core'
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class TypeScriptCodeErrorInterceptor implements ErrorHandler {
    // handle typeScript errors
    constructor(
        private injector: Injector
    ) {
    }

    handleError(error) {
        const toasterService = this.injector.get(ToastrService);
        let errorMessage = error;
        if (!navigator.onLine) {
            errorMessage = 'No Internet Connection';
            toasterService.error(errorMessage, '', { positionClass: 'toast-center-center' ,timeOut: 10000 });
        }
        console.log(errorMessage);
    }
}